'use strict';

$( function() {
	setTimeout( function() {
		setupSlider();
	}, 150 );
} );

function setImage( element ) {
	var image = element.data( 'image' );
	element.css( 'background-image', 'url(\'' + image + '\')' );
}

function setupSlider() {
	var slider = $( '.slider' ).flickity( {
		wrapAround: true,
		autoPlay: false
	} );

	$( '.slider' ).addClass( 'slide-count-' + $( '.slide' ).length );

	slider.on( 'cellSelect', function() {
		var flkty = $( this ).data( 'flickity' );
		setImage( $( flkty.selectedElement ) );
		setImage( $( flkty.selectedElement ).next() );
		setImage( $( flkty.selectedElement ).prev() );
	} );
}
